// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, dateTitle, timeTitle, eventTitle } from '../../messages/main';
/**
 * @hidden
 */
var AgendaViewHeadVue2 = {
  name: 'KendoAgendaViewHead',
  props: {
    monthSlots: Array,
    dateHeaderCell: [String, Function, Object]
  },
  inject: {
    ri: {
      default: null
    },
    kendoLocalizationService: {
      default: null
    },
    ks: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var localization = provideLocalizationService(this);
    return h("div", {
      "class": "k-scheduler-row",
      key: this.ri.groupIndex
    }, [h("div", {
      "class": "k-scheduler-cell k-heading-cell k-group-cell k-scheduler-datecolumn"
    }, [localization.toLanguageString(dateTitle, messages[dateTitle])]), h("div", {
      "class": "k-scheduler-cell k-heading-cell k-group-cell k-scheduler-timecolumn"
    }, [localization.toLanguageString(timeTitle, messages[timeTitle])]), h("div", {
      "class": "k-scheduler-cell k-heading-cell k-scheduler-eventcolumn"
    }, [localization.toLanguageString(eventTitle, messages[eventTitle])])]);
  }
};
/**
 * @hidden
 */
var AgendaViewHead = AgendaViewHeadVue2;
export { AgendaViewHead, AgendaViewHeadVue2 };